const simpleVariant = () => ({
  table: {
    mt: '20px',
    bg: 'white',
  },
  th: {
    color: 'black',
    borderBottom: '2px',
    width: '180px',
  },
  tbody: {
    bg: 'lightContrast',
  },
  td: {
    borderBottom: '1px',
    borderColor: '#E2E8F0',

  },
  tfoot: {
    tr: {
      '&:last-of-type': { th: { borderBottomWidth: 0 } },
    },
  },
});

const variants = {
  simple: simpleVariant,
};

export default { variants };
